<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="類型" prop="type" >-->
<!--        <a-select v-model="form.type" placeholder="请選择類型">-->
<!--          <a-select-option :key="0">单選</a-select-option>-->
<!--          <a-select-option :key="1">多選</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="标题名称" prop="tagTitle" >
        <a-input v-model="form.tagTitle" placeholder="请输入标题名称" />
      </a-form-model-item>
<!--      <a-form-model-item label="标题名称(英文)" prop="tagTitleEn" >-->
<!--        <a-input v-model="form.tagTitleEn" placeholder="请输入标题名称(英文)" />-->
<!--      </a-form-model-item>-->


      <a-form-model-item label="选项">
        <a-row type="flex" justify="space-between">
          <a-col :flex="4">
            <a-input placeholder="请输入选项內容" v-model="commonText"></a-input>
          </a-col>
<!--          <a-col :flex="4" style="margin-left: 10px">-->
<!--            <a-input placeholder="请输入选项內容(英文)" v-model="commonTextEn"></a-input>-->
<!--          </a-col>-->
          <a-col :flex="1">
            <div class="flex align-center justify-end" style="height: 100%">
              <a-button type="primary" @click="addOptionData">添加</a-button>
            </div>
          </a-col>
        </a-row>
        <a-table
          rowKey="id"
          :columns="columns"
          :data-source="optionList"
          :pagination="false"
          :bordered="true"
          style="margin-top: 10px"
        >


          <div slot="imgUrl" slot-scope="text,record">
            <a-upload
              listType="picture-card"
              class="avatar-uploader"
              v-model="record.imgUrl"
              :showUploadList="false"
              :beforeUpload="(file) => {
                return beforeUpload(file,record)
              }"
              :customRequest="(file) => {
                handleChange(file,record)
              }"
            >
              <img
                v-if="record.imgUrl"
                :src="record.imgUrl"
                alt="logo"
                style="height:104px;max-width:300px"/>
              <div v-else>
                <a-icon :type="record.uploadLoading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </div>
          <span slot="isOpen" slot-scope="text, record">
                        <a-switch checkedChildren="是" unCheckedChildren="否" v-model="record.isOpen == 1" @change="changeIsOpen($event,record)"/>
                      </span>
                        <a-input placeholder="请输入选项內容" v-model="record.tagTitle" slot="tagTitle" slot-scope="text, record,index"></a-input>
<!--                        <a-input placeholder="请输入选项內容(英文)" v-model="record.tagTitleEn" slot="tagTitleEn" slot-scope="text, record,index"></a-input>-->
                        <a-input-number v-model="record.sort"  slot="sort" slot-scope="text, record,index" :min="0" :step="1"></a-input-number>
                                <span slot="operation" slot-scope="text, record,index">
                                  <a-divider type="vertical"  />
                                    <a @click="handleDelete(record,item,index)">
                                      <a-icon type="delete" />删除
                                    </a>
                                </span>
                      </a-table>
                    </a-form-model-item>
              <!--      <a-form-model-item label="标题名称(简体)" prop="tagTitleCn" >-->
<!--        <a-input v-model="form.tagTitleCn" placeholder="请输入标题名称(简体)" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="标题名称(马来)" prop="tagTitleBm" >-->
<!--        <a-input v-model="form.tagTitleBm" placeholder="请输入标题名称(马来)" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="标题名称(印尼)" prop="tagTitleIn" >-->
<!--        <a-input v-model="form.tagTitleIn" placeholder="请输入标题名称(印尼)" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="背景图" prop="coverUrl" >-->
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.imgUrl"-->
<!--          :showUploadList="false"-->
<!--          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"-->
<!--          :beforeUpload="beforeUpload"-->
<!--          :customRequest="handleChange"-->
<!--        >-->
<!--          <img-->
<!--            v-if="form.imgUrl"-->
<!--            :src="form.imgUrl"-->
<!--            alt="logo"-->
<!--            style="height:104px;max-width:300px"/>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">上传</div>-->
<!--          </div>-->
<!--        </a-upload>-->
<!--      </a-form-model-item>-->
      <!--      <a-form-model-item style="display: flex" label="颜色" prop="colors" >-->
      <!--        <el-color-picker style="margin-left: 100%"  v-model="form.colors" />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getTag, addTag, updateTag, changeIsOpen} from '@/api/shortVideo/video/tag'
import {uploadOss, uploadObject} from "@/api/tool/oss";
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      uploadLoading: false,
      optionList:[],
      commonText:"",
      commonTextEn: "",
      columns: [{
        title: '选项內容',
        dataIndex: 'tagTitle',
        align: 'center',
        scopedSlots: { customRender: 'tagTitle' },
      },
      //   {
      //   title: '选项內容(英文)',
      //   dataIndex: 'tagTitleEn',
      //   align: 'center',
      //   scopedSlots: { customRender: 'tagTitleEn' },
      // },
        {
        title: '图片',
        dataIndex: 'imgUrl',
        align: 'center',
        scopedSlots: { customRender: 'imgUrl' },
      },{
        title: '排序(从小到大)',
        dataIndex: 'sort',
        align: 'center',
        scopedSlots: { customRender: 'sort' },
      },
        {
          title: '是否启用',
          dataIndex: 'isOpen',
          align: 'center',
          scopedSlots: { customRender: 'isOpen' }
        },
        {
        title: '操作',
        dataIndex: 'operation',
        width: '18%',
        scopedSlots: { customRender: 'operation' },
        align: 'center'
      }],
      // 表单参数
      form: {
        id: null,

        tagTitle: null,

        tagTitleEn: null,
        tagTitleCn: null,
        tagTitleBm: null,
        tagTitleIn: null,

        colors: null,

        createTime: null,

        remark: null,
        type:0,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        tagTitle: [
          { required: true, message: '标题名称不能為空' }
        ],
        colors: [
          { required: true, message: '请選择颜色' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    changeIsOpen (e,record) {
      record.isOpen = e ? 1 : 0
    },
    handleDelete(record,item,index) {
      this.optionList.splice(index,1);
    },
    addOptionData() {
      if(this.commonText) {
        this.optionList.push({
          id:"",
          tagTitle:this.commonText,
          tagTitleEn:"",
          sort:100,
          isOpen:1,
          imgUrl:"",
          uploadLoading:false
        })
        this.commonText = "";
        this.commonTextEn = "";
      } else {
        this.$message.error("请输入选项內容");
      }

    },
    onClose () {
      this.open = false
      this.form = {
             id: null,

            tagTitle: null,

            tagTitleEn: null,
        tagTitleCn: null,
        tagTitleBm: null,
        tagTitleIn: null,
        type:0,
            colors: null,

            createTime: null,

            remark: null
      }
      this.commonText = "";
      this.commonTextEn = "";
      this.optionList = []
    },

    handleChange(file, record) {
      const _this = this
      const uploadFile = file.file
      const prefix = 'videoTag'
      const url = uploadOss(uploadFile.name, prefix)
      record.uploadLoading = true
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          record.imgUrl = res
          record.uploadLoading = false
          _this.$message.success('上传成功')
        })
      })
    },
    beforeUpload: function (file,record) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传圖片')
        record.uploadLoading = false

        return false
      }
      record.imgUrl = ''
      // TODO 驗證文件大小
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        tagTitle: null,
        tagTitleEn: null,
        colors: null,
        createTime: null,
        remark: null
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.form.colors = ''
      this.form.tagTitle = ''
      // this.form={
      //   id: null,
      //
      //   tagTitle: null,
      //
      //   colors: null,
      //
      //   createTime: null,
      //
      //   remark: null,
      //
      // }
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTag({ 'id': id }).then(response => {
        this.form = response.data;
        response.data.videoTagOptionList.forEach(i => {
          i.uploadLoading=false
        })
        this.optionList = response.data.videoTagOptionList;
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.form.videoTagOptionList = this.optionList;
          if (this.form.id !== undefined && this.form.id !== null) {
            updateTag(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
              this.form = {
                id: null,

                tagTitle: null,

                colors: null,

                createTime: null,

                remark: null

              }
            }).finally(() => {
              this.submitLoading = false
              this.form = {
                id: null,

                tagTitle: null,

                colors: null,

                createTime: null,

                remark: null

              }
            })
          } else {
            addTag(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
              this.form = {
                id: null,

                tagTitle: null,

                colors: null,

                createTime: null,

                remark: null

              }
            }).finally(() => {
              this.submitLoading = false
              this.form = {
                id: null,

                tagTitle: null,

                colors: null,

                createTime: null,

                remark: null

              }
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
